import { dropNCharacters } from '#utils/string';

export const getFileName = srcUrl => {
  const mainUrlLength = process.env.REACT_APP_WEB_FILES_URL.length + 1;
  return dropNCharacters(mainUrlLength)(srcUrl);
};
